import * as React from 'react';
import { Link } from 'react-router-dom';

interface NavigationLinkProps {
	text: string;
	isActive?: boolean;
	to: string;
}

export const NavigationLink: React.FC<NavigationLinkProps> = ({
	text,
	isActive = false,
	to,
}) => {
	return (
		<Link to={to} className='flex items-center gap-x-0.5'>
			<span
				className={`text-base ${
					isActive ? 'text-neutral-800 font-medium' : 'text-neutral-600'
				} hover:text-neutral-800 transition-colors`}
			>
				{text}
			</span>
			{isActive && (
				<div className='w-1.5 h-1.5 mt-2.5 rounded-full bg-[#fbb040]' />
			)}
		</Link>
	);
};
